import { IAccountDocument } from '@epicuro-next/data/documents';
import { createAction, props } from '@ngrx/store';

export const setUnsignedUserTerms = createAction(
  '[User] Set unsigned user terms',
  props<{
    documents: ReadonlyArray<IAccountDocument>;
  }>(),
);

export const acceptUserTerms = createAction(
  '[User] Accept user term',
  props<{ document: IAccountDocument }>(),
);

export const acceptUserTermsSuccess = createAction(
  '[User] Accept user term success',
  props<{ document: IAccountDocument }>(),
);

export const acceptUserTermsFail = createAction('[User] Accept user term fail');

export const allUserTermsAccepted = createAction(
  '[User] All user terms accepted',
);
